import { Button, Form, Modal } from "react-bootstrap"
import i18next from "i18next"
import _ from 'lodash';
import { useState } from "react";
import { MdOutlineWarningAmber } from "react-icons/md";

type Props = {
  isOpen?: boolean;
  closeModal?: (reload?: boolean) => void;
  doUnquotable: (reason: string) => void;
}

const MakeRequestUnquotableModal: React.FC<Props> = ({ isOpen, doUnquotable, closeModal = _.noop }) => {
  const [reason, setReason] = useState('');

  const onClose = () => {
    setReason('');
    closeModal();
  }

  return (
    <Modal show={isOpen} backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <div className="mb-3">
          <MdOutlineWarningAmber size={44} />
        </div>
        {i18next.t('unquotable_request_confirmation_message')}
        <Form>
          <Form.Group className="mb-3 mt-3 text-start">
            <Form.Control
              as="textarea"
              className="p-3"
              placeholder={i18next.t('insert_reasons')}
              rows={3}
              onChange={(e) => setReason(e?.target?.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='link' onClick={onClose}>
          {i18next.t('cancel')}
        </Button>
        <Button onClick={() => doUnquotable(reason)} disabled={!reason?.trim()}>
          {i18next.t('make_it_unquotable')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MakeRequestUnquotableModal;
